<template>
    <gj-modal
            v-bind="$attrs"
            v-on="$listeners"
            size="auto"
            :visible.sync="modalVisible"
            :confirmLoading="confirmLoading"
            @cancel="cancel"
            @close="cancel"
            @confirm="confirm">
        <span slot="header">费用分摊</span>
        <el-form
                slot="content"
                inline
                :model="form"
                ref="form"
        >
            <el-row >
                <el-form-item prop="countryData">
                    <gj-country-server-select v-model="form.countryData"/>
                </el-form-item>
                <el-form-item prop="feeName">
                    <gj-select
                            v-model="form.feeName"
                            placeholder="全部费用"
                            :options="feeNameOption"
                            >
                    </gj-select>
                </el-form-item>
                <el-form-item>
                    <gj-date-picker
                            v-model="form.feeShareMonth"
                            format="yyyy-MM"
                            value-format="yyyy-MM"
                            type="month"
                            :clearable="false"
                    >
                    </gj-date-picker>
                </el-form-item>
                <el-form-item>
                    <gj-button type="primary" @click="handleFetchCost">查询</gj-button>
                    <gj-button type="default" @click="handleRestForm">重置</gj-button>
                </el-form-item>
            </el-row>
            <el-row>
               <el-col :span="12">
                 <gj-button type="primary" @click="importCost">导入</gj-button>
               </el-col>
              <el-col :span="12">

              </el-col>
            </el-row>
            <gj-table
                    :data="tableData"
                    :columns="columns"
                    :loading="loading"
                    :adapt-height="false"
                    :height="410">
                <template v-slot:header:asinHeader>
                   分摊ASIN
                  <gj-tooltip content="同一店铺/国家下的相同费用项，均全部分摊">
                    <gj-icon iconfont="iconbangzhushouce" class="gj-help--icon" style="font-size: 16px"></gj-icon>
                  </gj-tooltip>
                </template>
                <template v-slot:feeTotal="{ row }">
                    <span>{{ row.currencySymbol }}{{ row.feeTotal | defaultShow }}</span>
                </template>
                <template v-slot:shareDateRange="{ row }">
                    <gj-date-picker v-model="row.shareDateRange"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="daterange"
                                    :disabled-date="disabledDate" @change="handleDateChange(row)">
                    </gj-date-picker>
                </template>
                <template v-slot:asins="{ row }">
                    <el-select
                            v-model="row.asins"
                            size="small"
                            multiple
                            palceholder="请选择分摊的ASIN"
                            filterable
                            remote
                            :remote-method="debounceFetchAsin"
                    >
                        <el-option v-for="option in asinOption" :label="option.text" :value="option.id" :key="option.id"></el-option>
                    </el-select>
                </template>
                <template v-slot:op="{ row }">
                    <gj-button type="text" @click="handleShowAverageDetail(row)" :disabled="!row.shareDateRange || !row.shareDateRange.length || !row.asins || !row.asins.length">分摊详情</gj-button>
                </template>
            </gj-table>
        </el-form>
    </gj-modal>
</template>

<script>

    import {
        getFeeAllOptions,
        postFeeShareList,
        getFeeShareAsin,
        postSaveFeeShare
    } from '@/api/finance'

    import {
        formValidatorMixin,
        modalMixIn,
        responseMixin
    } from "@/minxins";
    import { mapGetters } from "vuex";
    import { debounce } from 'lodash'
    import { startOfMonth, endOfMonth } from 'date-fns'

    import CostAverageDetailModal from './cost-average-detail-modal'
    import CostCenterImport from "@/views/modules/finance/cost-center/cost-center-import";
    import ImportAverageExpenses from './import-average-expenses'

    export default {
        name: "cost-average-modal",
        props: {
            dateValue: {
                type: [Date, String],
                default: ''
            }
        },
        mixins: [modalMixIn, formValidatorMixin, responseMixin],
        data () {
            return {
              transferOrder:{},
                form: {
                    countryData: {
                        countryIds: [],
                        marketIds: []
                    },
                    feeName: '',
                    feeShareMonth: '',
                },
                columns: [
                    {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '120px', options: () => this.marketOption, fixed: 'left'},
                    {id: 'feeShowName', header: '费用名称', field: 'feeShowName', minWidth: '100px', fixed: 'left'},
                    {id: 'description', header: '描述', field: 'description', minWidth: '200px', },
                    {id: 'feeTotal', header: '费用金额', field: 'slot:feeTotal', minWidth: '100px'},
                    {id: 'shareDateRange', header: '分摊日期范围', field: 'slot:shareDateRange', minWidth: '300px'},
                    {id: 'asins', header: 'slot:asinHeader', field: 'slot:asins', minWidth: '220px'},
                    {id: 'op', header: '操作', field: 'slot:op', minWidth: '100px'},
                ],
                tableData: [],
                asinOption: [],
                feeNameOption: [],
                loading: false,
                disabledDate: (date) => {
                    // console.warn(date, this.form.feeShareMonth)
                    let dateValue = new Date(this.form.feeShareMonth)

                    const startOfMonthDate = startOfMonth(dateValue)
                    const endOfMonthDate = endOfMonth(dateValue)
                    return date < startOfMonthDate || date > endOfMonthDate
                },
                debounceFetchAsin: debounce(this.getFeeShareAsin, 100)
            }
        },
        created () {
            this.initForm()
            this.postFeeShareList()
        },
        computed: {
            ...mapGetters({
                marketOption: 'marketOption'
            }),
        },
        methods: {
          importCost() {
            this.$gjCreate(ImportAverageExpenses,{
              on: {
                importSuccess: (data) => {
                  this.updateItems(data);
                },
                importPartSuccess: (data) => {
                  this.updateItems(data);
                }
              }
            } )
          },
          updateItems(data){
            this.postFeeShareList()
          },
            /**
             * 日期选择
             */
            handleDateChange (row) {
                row.shareBeginDate = row.shareDateRange[0] || ''
                row.shareEndDate = row.shareDateRange[1] || ''
            },
            /**
             * 分摊详情
             */
            handleShowAverageDetail (row) {
                this.$gjCreate(CostAverageDetailModal, {
                    props: {
                        rowItem: row,
                        formItem: this.form
                    }
                })
            },
            /**
             * 查询
             */
            handleFetchCost () {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.postFeeShareList()
                    }
                })
            },
            /**
             * 重置
             */
            handleRestForm () {
                this.form.countryData.countryIds = [];
                this.form.countryData.marketIds = [];
                this.form.feeName = ''
            },
            /**
             * 初始化form
             */
            initForm () {
                this.form.feeShareMonth = this.dateValue
                this.getFeeAllOptions()
            },
            /**
             * 查询费用分摊列表
             */
            postFeeShareList () {
                let { countryData, feeName = '', feeShareMonth = '' } = this.form
                let { countryIds = [], marketIds = [] } = countryData
                let params = {
                    countryIds,
                    marketIds,
                    feeName,
                    feeShareMonth
                }
                this.loading = true
                postFeeShareList(params).then((res = []) => {
                    this.tableData = res.map(v => {
                        v.asins = Array.isArray(v.asins) ? v.asins : v.asins ? [v.asins] : []
                        v.shareDateRange = [v.shareBeginDate || '', v.shareEndDate || '']
                        return v
                    })
                }).complete(() => this.loading = false)
            },
            /**
             * 获取费用名称下拉选项
             */
            getFeeAllOptions () {
                getFeeAllOptions().then((res = []) => this.feeNameOption = res)
            },
            /**
             * 获取分摊asin
             */
            getFeeShareAsin (value) {
                let { feeShareMonth = '', countryData, feeName = '' } = this.form
                let { countryIds = [], marketIds = [] } = countryData
                let params = {
                    month: this.form.feeShareMonth,
                    feeShareMonth,
                    countryIds,
                    marketIds,
                    feeName,
                    inputValue: value
                }
                getFeeShareAsin(params).then(res => this.asinOption = res)
            },
            /**
             * 检测必填项
             */
            checkParams () {
                const data = this.tableData
                let valid = {
                    status: true,
                    message: ''
                }

                for (let i in data) {
                    const item = data[i]
                    if (!item.shareDateRange || !item.shareDateRange.length) {
                        valid = {
                            status: false,
                            message: `请选择第${Number(i) + 1}行分摊日期范围`
                        }
                        break;
                    }

                    if (!item.asins || !item.asins.length) {
                        valid = {
                            status: false,
                            message: `请选择第${Number(i) + 1}行分摊ASIN`
                        }
                        break;
                    }
                }

                return valid
            },
            cancel(){
                this.$emit("cancel");
                this.$gjDestroy();
            },
            confirm () {
                const valid = this.checkParams()
                if (!valid.status) {
                    this.$gjMessage.warning(valid.message)
                    return
                }

                let params = this.tableData
                postSaveFeeShare(params).then(res => {
                    if (res) {
                        this.$gjMessage.success('分摊成功')
                        this.$gjDestroy()
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
